import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import clientRoutes from '../../../components/client/clientRoutes';

const update = createAsyncThunk(
  'thunk/client/read',
  async (arg, thunkAPI) => {
    const response = await apiFetch(clientRoutes.api.generate.read(arg?.id), {
      method: 'GET',
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default update;
